import { PaletteTheme } from '@kite-js/theme-types';
import { coreDefaultTheme } from '@kite-js/theme';

import corePalette from './core';
import systemPalette from './system';
import semanticPalette from './semantic';

const palette: PaletteTheme = {
    ...coreDefaultTheme.palette,
    ...corePalette,
    ...systemPalette,
    ...semanticPalette,
};

export default palette;
